<template>
  <v-card>
    <v-card-title>
      <span>Escolha os usuários que gostaria de enviar as notificações:</span>
    </v-card-title>
    <v-card-text>
      <form-group class="ma-0 pa-0 mt-3">
        <v-row>
          <only-search-filter />
          <v-spacer />
          <div class="mr-2">
            <v-row>
              <v-col>
                <v-checkbox
                  id="input:allUsers"
                  v-model="allUsers"
                  label="Enviar para todos"
                />
              </v-col>
            </v-row>
          </div>
          <notification-custom-list-btn />
          <notification-confirm-user
            v-show="!allUsers"
            ref="confirm"
          />
          <notification-user-filter />
        </v-row>
        <v-row v-show="!allUsers">
          <v-col cols="9">
            <users-notification-list />
          </v-col>
          <v-col cols="3">
            <notification-user-selected />
          </v-col>
        </v-row>
        <v-row v-if="allUsers">
          <v-col cols="12">
            <span>Todos os usuários ativos do cardmais irão receber as notificações</span>
          </v-col>
        </v-row>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import UsersNotificationList from 'Modules/contacard/communication/notifications/components/tables/NotificationUserList.vue';
import NotificationUserFilter from 'Modules/contacard/communication/notifications/components/filters/NotificationUserFilter.vue';
import OnlySearchFilter from '@/app/arch/components/crud/components/OnlySearchFilter.vue';
import NotificationUserSelected from 'Modules/contacard/communication/notifications/components/lists/NotificationUserSelected.vue';
import NotificationConfirmUser from 'Modules/contacard/communication/notifications/components/buttons/NotificationConfirmUser.vue';
import NotificationCustomListBtn from 'Modules/contacard/communication/notifications/components/buttons/NotificationCustomListBtn.vue';

export default {
  name: 'NotificationUsersContent',
  components: {
    FormGroup,
    UsersNotificationList,
    NotificationUserFilter,
    OnlySearchFilter,
    NotificationUserSelected,
    NotificationConfirmUser,
    NotificationCustomListBtn,
  },
  data: () => ({
    allUsers: null,
  }),
  computed: {
    refConfirm() {
      const { confirm } = this.$refs;
      return confirm || {
        setAllUsersFilter: () => {},
      };
    },
  },
  watch: {
    allUsers: {
      immediate: true,
      handler(isAll) {
        if (isAll) {
          this.setAllUsersToReceive();
        }
      },
    },
  },
  methods: {
    setAllUsersToReceive() {
      this.refConfirm.setAllUsersFilter();
    },
  },
};
</script>
